/**
 * @generated SignedSource<<34c8a18346ade7d07a09baa2dd0eddc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedRefetchContainer_viewer$data = {
  readonly isEligibleForRerank?: boolean | null;
  readonly " $fragmentType": "BuySharedRefetchContainer_viewer";
};
export type BuySharedRefetchContainer_viewer$key = {
  readonly " $data"?: BuySharedRefetchContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedRefetchContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "rerankGuestId"
    },
    {
      "kind": "RootArgument",
      "name": "rerankUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedRefetchContainer_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "guestId",
              "variableName": "rerankGuestId"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "rerankUserId"
            }
          ],
          "kind": "ScalarField",
          "name": "isEligibleForRerank",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2b24f76c92cccaa7a5e1bb915c2461da";

export default node;
